export const AppPermissions = {
  ManageAll: {
    id: 1,
    name: 'ManageAll',
    alias: 'Manage All',
    state: 0
  },
  ManageComplianceAdmins: {
    id: 2,
    name: 'ManageComplianceAdmins',
    alias: 'Manage Configure Readiness',
    state: 0
  },
  ManageApprovers: {
    id: 3,
    name: 'ManageApprovers',
    alias: 'Manage Approvers',
    state: 0
  },
  ManageReportDashboardAccess: {
    id: 4,
    name: 'ManageReportDashboardAccess',
    alias: 'Manage Dashboard Access',
    state: 0
  },
  ManageProxy: {
    id: 5,
    name: 'ManageProxy',
    alias: 'Manage Proxy Permission',
    state: 0
  },
  SuperAdmin: {
    id: 6,
    name: 'SuperAdmin',
    state: 0
  },
  ManageSecurity: {
    id: 7,
    name: 'ManageSecurity',
    alias: 'Manage Security',
    state: 0
  },
  ConfigureComplianceReadiness: {
    id: 8,
    name: 'ConfigureComplianceReadiness',
    alias: 'Configure Readiness',
    state: 0,
    managePermissionId: 2
  },
  FirstApprover: {
    id: 9,
    name: 'FirstApprover',
    alias: 'First',
    state: 0,
    managePermissionId: 3
  },
  SecondApprover: {
    id: 10,
    name: 'SecondApprover',
    alias: 'Second',
    state: 0,
    managePermissionId: 3
  },
  BuildReports: {
    id: 11,
    name: 'BuildReports',
    alias: 'Dashboard Access',
    state: 0,
    managePermissionId: 4
  },
  Proxy: {
    id: 12,
    name: 'Proxy',
    alias: 'Proxy Permission',
    state: 0,
    managePermissionId: 5
  },
  Security: {
    id: 13,
    name: 'Security',
    alias: 'QR Scan',
    state: 0,
    managePermissionId: 7
  },
  Approval: {
    name: 'Approval',
    alias: 'Approval',
    state: 0,
    managePermissionId: 3,
    options: ['First', 'Second'],
  },
  Admin : {
    id: 14,
    name: 'Admin',
    state: 0
  }
};
